module.exports = __webpack_public_path__ + "img/overwiev.7ae11175.svg";